import React from 'react';
import useToolStore, { TOOL_TYPES, hasToolPreview } from '../../store/useToolStore';
import LoaderGenerator, { LoaderPreviewComponent } from './LoaderGenerator/LoaderGenerator';
import GradientGenerator, { GradientPreviewComponent } from './GradientGenerator/GradientGenerator';
import CardGenerator, { CardPreviewComponent } from './CardGenerator/CardGenerator';
import AnimationGenerator, { AnimationPreviewComponent } from './AnimationGenerator/AnimationGenerator';
import AlertGenerator, { AlertPreviewComponent } from './AlertGenerator/AlertGenerator';
import PhotoPickerGenerator, { PhotoPickerPreviewComponent } from './PhotoPickerGenerator/PhotoPickerGenerator';
import JsonToModelGenerator from './JsonToModelGenerator/JsonToModelGenerator';
import ApiGenerator, { ApiGeneratorPreviewComponent } from './ApiGenerator/ApiGenerator';
import StoryboardConverter, { StoryboardConverterPreviewComponent } from './StoryboardConverter/StoryboardConverter';
import PostmanImporter from './PostmanImporter/PostmanImporter';
import ShadowGenerator, { ShadowPreviewComponent } from './ShadowGenerator/ShadowGenerator';
import ButtonBuilder, { ButtonPreviewComponent } from './ButtonBuilder/ButtonBuilder';
import GridGenerator, { GridPreviewComponent } from './GridGenerator/GridGenerator';
import ColorPaletteGenerator from './ColorPaletteGenerator/ColorPaletteGenerator';
import DeviceFrame from '../DeviceFrame/DeviceFrame';

export const ToolControls = () => {
  const activeTool = useToolStore((state) => state.activeTool);

  switch (activeTool) {
    case TOOL_TYPES.LOADER:
      return <LoaderGenerator />;
    case TOOL_TYPES.GRADIENT:
      return <GradientGenerator />;
    case TOOL_TYPES.CARD:
      return <CardGenerator />;
    case TOOL_TYPES.ANIMATION:
      return <AnimationGenerator />;
    case TOOL_TYPES.ALERT:
      return <AlertGenerator />;
    case TOOL_TYPES.PHOTO_PICKER:
      return <PhotoPickerGenerator />;
    case TOOL_TYPES.STORYBOARD_CONVERTER:
      return <StoryboardConverter />;
    case TOOL_TYPES.JSON_TO_MODEL:
      return <JsonToModelGenerator />;
    case TOOL_TYPES.API_GENERATOR:
      return <ApiGenerator />;
    case TOOL_TYPES.POSTMAN_IMPORTER:
      return <PostmanImporter />;
    case TOOL_TYPES.SHADOW:
      return <ShadowGenerator />;
    case TOOL_TYPES.BUTTON:
      return <ButtonBuilder />;
    case TOOL_TYPES.GRID:
      return <GridGenerator />;
    case TOOL_TYPES.PALETTE:
      return <ColorPaletteGenerator />;
    default:
      return <div className="p-6 text-gray-900 dark:text-white">Select a tool</div>;
  }
};

export const ToolPreview = () => {
  const activeTool = useToolStore((state) => state.activeTool);

  // Return null if tool doesn't have preview
  if (!hasToolPreview(activeTool)) {
    return null;
  }

  const renderPreview = () => {
    switch (activeTool) {
      case TOOL_TYPES.LOADER:
        return <LoaderPreviewComponent />;
      case TOOL_TYPES.GRADIENT:
        return <GradientPreviewComponent />;
      case TOOL_TYPES.CARD:
        return <CardPreviewComponent />;
      case TOOL_TYPES.ANIMATION:
        return <AnimationPreviewComponent />;
      case TOOL_TYPES.ALERT:
        return <AlertPreviewComponent />;
      case TOOL_TYPES.PHOTO_PICKER:
        return <PhotoPickerPreviewComponent />;
      case TOOL_TYPES.STORYBOARD_CONVERTER:
        return <StoryboardConverterPreviewComponent />;
      case TOOL_TYPES.API_GENERATOR:
        return <ApiGeneratorPreviewComponent />;
      case TOOL_TYPES.SHADOW:
        return <ShadowPreviewComponent />;
      case TOOL_TYPES.BUTTON:
        return <ButtonPreviewComponent />;
      case TOOL_TYPES.GRID:
        return <GridPreviewComponent />;
      default:
        return (
          <div className="text-gray-500 text-center">
            <p>Preview will appear here</p>
          </div>
        );
    }
  };

  return <DeviceFrame>{renderPreview()}</DeviceFrame>;
};

const ToolRouter = () => null;

export default ToolRouter;

